module.exports = __webpack_public_path__ + "img/antes_despues_28.ce0a4323.png";